// voltage: force the Shop Pay installments text to the theme's body weight.
//
// WHY THIS NEEDS JS. Shopify renders the banner into an OPEN shadow root — confirmed by
// reading their bundle (shop-js/modules/v2/chunk.PortalProvider_*.esm.js calls
// attachShadow({mode:"open"}); there is no iframe anywhere in the payment-terms module).
// Inherited properties like font-size DO cross a shadow boundary, which is why setting `font`
// on the host in voltage.css fixes the SIZE. Weight is different: the price is bold because
// of a rule inside their own adoptedStyleSheets, and a descendant's explicit value always
// beats an inherited one. The only way to win is a stylesheet inside the same shadow tree.
//
// Two details from their implementation:
//  - attachShadow is called on a DIV their renderer creates, not on <shopify-payment-terms>,
//    so host.shadowRoot is null. We walk descendants to find the real root.
//  - Their styles arrive via adoptedStyleSheets, which the spec orders BEFORE a shadow tree's
//    own <style> elements — so an appended <style> already wins. !important is belt-and-braces
//    against a future specificity change we cannot see.
//
// ⚠️ UNSUPPORTED. This reaches into third-party internals. If Shopify renames
// #shopify-installments the rule simply stops matching and the text goes bold again — it
// degrades quietly rather than breaking the banner. Re-check after any Shop Pay change.

(function () {
  if (window.voltageInstallmentsWeight) return;
  window.voltageInstallmentsWeight = true;

  // Custom properties inherit through the shadow boundary, so we can reuse the theme's own
  // body weight rather than hardcoding one. Falls back to 400 if the var is ever removed.
  // Match the theme's `body` rule exactly (theme.css sets font + letter-spacing there).
  // Custom properties inherit across the shadow boundary, so these resolve to the merchant's
  // real type settings rather than hardcoded values, and @font-face declared in the document
  // (stevie-sans, via Typekit) applies inside shadow trees too.
  //
  // font-family is the one that actually matters: body is hardcoded to stevie-sans while
  // Shopify's sheet sets its own stack, and a different typeface at the same weight reads as
  // heavier and spaces differently. Weight alone was never going to close the gap.
  //
  // font-size is deliberately NOT forced — the size already reads correctly via host
  // inheritance, and overriding it on every descendant risks disturbing the logo's sizing.
  var CSS_TEXT =
    '#shopify-installments, #shopify-installments * {' +
    ' font-family: var(--text-font-family) !important;' +
    ' font-weight: var(--text-font-weight, 400) !important;' +
    // Deliberately `normal`, NOT var(--text-letter-spacing). The theme's body rule carries
    // 0.04em (settings.text_font_letter_spacing = 4) and that was being applied here, which
    // read as too loose against the surrounding copy — Matthew flagged it twice on the live
    // page. Shopify sets no tracking of its own on the banner line (every `tracking-wider` in
    // their bundle is on modal content), so this is purely our call. Flip back to
    // var(--text-letter-spacing) if it ever reads too tight beside body text.
    ' letter-spacing: normal !important;' +
    ' }' +
    // The "?" help icon. Shopify renders it with Tailwind's `size-5` (1.25rem / 20px), which
    // reads large beside 13px body copy. Written as that exact value minus 3px so it still
    // scales if the root font-size ever changes, rather than freezing it at 17px.
    // Selector note: this stylesheet lives INSIDE the shadow root, so a bare svg selector
    // cannot leak to the page. viewBox 0 0 20 20 is unique to the question mark — the Shop Pay
    // logo and the other icons all use different viewBoxes, so this cannot touch them.
    ' svg[viewBox="0 0 20 20"] {' +
    ' width: calc(1.25rem - 3px) !important;' +
    ' height: calc(1.25rem - 3px) !important;' +
    ' }';

  var MARKER = 'data-voltage-installments';

  function inject(root) {
    if (!root || root.querySelector('style[' + MARKER + ']')) return;
    var style = document.createElement('style');
    style.setAttribute(MARKER, '');
    style.textContent = CSS_TEXT;
    root.appendChild(style);
  }

  function scan() {
    document.querySelectorAll('shopify-payment-terms').forEach(function (host) {
      if (host.shadowRoot) inject(host.shadowRoot);
      host.querySelectorAll('*').forEach(function (node) {
        if (node.shadowRoot) inject(node.shadowRoot);
      });
    });
  }

  // The banner is rendered asynchronously by Shopify's module, so poll briefly rather than
  // assuming it exists at parse time. Injection is idempotent, so repeat scans are free.
  var tries = 0;
  function retry() {
    scan();
    if (++tries < 40) setTimeout(retry, 250); // ~10s
  }
  retry();

  // Stretch lists payment_terms in block_types_allowing_partial_rerender, so changing variant
  // replaces the element and takes our <style> with it. Re-arm the poll when that happens.
  document.addEventListener('variant:change', function () {
    tries = 30; // a few more passes, not another full 10s
    setTimeout(retry, 100);
  });
})();
